import ImageOptimizer from './components/ImageOptimizer';
import { Analytics } from "@vercel/analytics/react"
import Landing from './components/Landing';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import { Routes, Route, BrowserRouter, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AboutUs from './components/AboutUs';
import ContactUs from './components/ContactUs';
import Sitemap from './components/Sitemap';
import BlogPost from './components/BlogPost';
import BlogIndex from './components/BlogIndex';
import ToolsIndex from './components/ToolsIndex';
import toolPages from './lib/toolPages';
import { useEffect } from 'react';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
};

function App() {
  return (
    <BrowserRouter>
      <>
        <Analytics></Analytics>
        <ScrollToTop />
        <Navbar />
        <main className="app-main">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/tool" element={<ImageOptimizer />} />
            <Route path="/tools" element={<ToolsIndex />} />
            {toolPages.map((tool) => (
              <Route
                key={tool.path}
                path={tool.path}
                element={<ImageOptimizer {...tool} canonicalPath={tool.path} />}
              />
            ))}
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/about" element={<AboutUs />} />
            {/* <Route path="/blog" element={<Blog />} /> */}
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/sitemap" element={<Sitemap />} />
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
          </Routes>
        </main>
        <Footer></Footer>
      </>
    </BrowserRouter>
  );
}

export default App
